import * as React from "react";
import { forwardRef } from "react";
const SvgConsultCompletePop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 27, height: 27, rx: 7.5, fill: "#FBFDFF", stroke: "#E6ECF1" }), /* @__PURE__ */ React.createElement("path", { d: "M19.3333 10L12 17.3333L8.66663 14", stroke: "#222222", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgConsultCompletePop);
export default ForwardRef;
